import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import MKBox from "components/MKBox";
import BirthdayCarousel from "../../../../../../components/BirthdayCarousel";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getHomeLinksByCountry } from "../../../../../../redux/actions/GetHomeLinksByCountryAction";
import TransparentBlogCard from "components/TransparentBlogCard";

function CardsSection() {
  const dispatch = useDispatch();
  const homeLinks = useSelector((state) => state.homeLinks);

  useEffect(() => {
    dispatch(getHomeLinksByCountry());
  }, [dispatch]);

  const links = homeLinks?.homeLinks || [];

  return (
    <MKBox component="section" py={2}>
      <Container>
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} sm={6} lg={4}>
            <BirthdayCarousel />
          </Grid>

          {links.length > 0 &&
            links.map((link, index) => (
              <>
                <Grid item xs={12} sm={6} lg={4}>
                  <TransparentBlogCard
                    key={index}
                    image={link.imagePath}
                    maxWidth={400}
                    maxHeight={205}
                    action={{
                      type: "external",
                      route: link.url,
                      color: "info",
                    }}
                  />
                </Grid>
              </>
            ))}
          <Grid item xs={12} sm={6} lg={4}></Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default CardsSection;
